import React from 'react';

const EmbedWidget = () => {
  return (
    <div className="bg-[#111] border border-[#1a1a1a] rounded p-4 mb-4" data-testid="embed-widget">
      <iframe 
        src="https://council-votes-admin.preview.emergentagent.com/widget/square.html" 
        width="300" 
        height="300" 
        frameBorder="0" 
        style={{ borderRadius: '16px', display: 'block', margin: '0 auto' }}
        title="Community Widget"
      />
    </div>
  );
};

export default EmbedWidget;
